module.exports = __webpack_public_path__ + "static/media/jafza.e784cd75.svg";